export const logger = () => (next) => (action) => {
  const result = next(action);

  if (process.env.NODE_ENV !== 'production' && !action.type.includes('@@') && !global.window) {
    const formatter = new Intl.DateTimeFormat('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      fractionalSecondDigits: 3,
    });
    console.log(`${formatter.format(Date.now())} DISPATCH ACTION -> ${action.type}`);
  }

  return result;
};

export default logger;
